export default setTimeout.bind(null,() => {
    const error = document.querySelector('.field-wrapper--error')
    error && error.scrollIntoView({ behavior: 'smooth', block: 'center' })
}, 100)